// extracted by mini-css-extract-plugin
module.exports = {"githubButton":"GitHubIconButton_githubButton__3okIP","githubIcon":"GitHubIconButton_githubIcon__2y9ls"};